import Skeleton from "./Skeleton";

const WIDTHS: string[] = ["60%", "45%", "55%", "70%"];

interface TableSkeletonProps {
  cols?: number;
  rows?: number;
}

export default function TableSkeleton({ cols = 4, rows = 5 }: TableSkeletonProps) {
  return (
    <div className="plist table-responsive">
      <table className="table">
        <thead>
          <tr className="chdr">
            {Array.from({ length: cols }).map((_, i) => (
              <th key={i}>
                <Skeleton width={80} height={12} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, r) => (
            <tr key={r} className="prow">
              {Array.from({ length: cols }).map((_, c) => (
                <td key={c} style={{ padding: "17px 12px" }}>
                  <Skeleton width={WIDTHS[c % WIDTHS.length]} height={14} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
